import React from 'react';

export const JSSK_SERVICE_ORDER_MAP: Record<string, number> = {
  'folic acid tab 400 mcg': 1,
  'iron folic acid tab': 2,
  'calcium + vitamin d3 tab': 3,
  'misoprostol tab for home delivery': 4,
  'albendazole tab after 14th week of gestation': 5,

  'haemoglobin test': 1,
  'urine test - albumin/sugar': 2,
  'blood sugar test - ogtt': 3,
  'syphilis/vdrl test': 4,
  'hiv screening test': 5,
  'hepatitis b surface antigen (hbsag) test': 6,
  'rapid malaria test': 7,
  'ultra sound screening': 8,

  'antenatal (anc)': 1,
  'delivery': 2,
  'postnatal (pnc)': 3,

  'complementary diet provided at the facility': 1,

  'home to institution': 1,
  'institution to institution': 2,
  'institution to home': 3,
};
// Category display order
export const JSSK_CATEGORY_ORDER = [
  'Free Drugs & Consumables',
  'Free Diagnostics',
  'Free Provision of Blood',
  'Free Diet',
  'Free Transport',
];

// Sub-category order for the consumables (medicine) section
export const JSSK_CONSUMABLES_SUBCATEGORY_ORDER = [
  'Medicine given in antenatal period',
  'Medicine given in postnatal period',
];


export const JSSK_SUBCATEGORY_DISPLAY_NAME_MAP: Record<string, string> = {
  'Medicine given in antenatal period':
    'Medicine given in Antenatal Period',

  'Medicine given in postnatal period':
    'Medicine given in Post Natal Period',

  'Diagnostic test included in Antenatal Care Period':
    'Diagnostic test included in Antenatal Care Period',

  'Free Blood Transfusion Provided At':
    'Free blood transfusions provided at',

  'Free Transport Provided Accross Care journey':
    'Free transport provided across care journey',

};

// Free Diagnostics services that are always disabled
export const JSSK_ALWAYS_DISABLED_DIAGNOSTICS = [
  'Ultrasonography',
];

// The category considered non-editable (sourced from ANC/Delivery/PNC)
export const JSSK_NON_EDITABLE_CATEGORY = 'Freedrugsandconsumables';

export const JSSK_FREE_DIAGNOSTICS_CATEGORY = 'FreeDiagnostics';